// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","130":"basket","443":"about","449":"notFound","535":"login","663":"guarantee","893":"products"}[chunkId] + "." + {"18":"dea26d3e","130":"11b78059","443":"54cbbf48","449":"2a3f2724","535":"aaef36e5","663":"42282fe1","893":"9bf964c6"}[chunkId] + ".css";
};